import StyledContainer from "style/styledContainer";
import styled from "styled-components";

import cardOneLeft from "assets/images/card_one_left.png";
import cardOneRight from "assets/images/card_one_right.png";

import cardTwoLeft from "assets/images/card_two_left.png";
import cardTwoRight from "assets/images/card_two_right.png";

import cardThreeLeft from "assets/images/card_three_left.png";
import cardThreeRight from "assets/images/card_three_right.png";

import cardFourLeft from "assets/images/card_four_left.png";
import cardFourRight from "assets/images/card_four_right.png";


import { AnimatePresence, motion } from "framer-motion";
import { useCallback } from "react";

type Props = {
  index: number;
  type?: string;
  title: string;
  rightText: string;
  year?: string;
};

const SlideCardCom = ({
  type = "0",
  title,
  rightText,
  year = "",
  index,
}: Props) => {
  const getLeftImg = useCallback((index: number) => {
    let tempImg = cardOneLeft;
    switch (index) {
      case 0:
        tempImg = cardOneLeft;
        break;
      case 1:
        tempImg = cardTwoLeft;
        break;
      case 2:
        tempImg = cardThreeLeft;
        break;
      case 3:
        tempImg = cardFourLeft;
        break;
    }
    return tempImg
  }, []);

  const getRightImg = useCallback((index: number) => {
    let tempImg = cardOneRight;
    switch (index) {
      case 0:
        tempImg = cardOneRight;
        break;
      case 1:
        tempImg = cardTwoRight;
        break;
      case 2:
        tempImg = cardThreeRight;
        break;
      case 3:
        tempImg = cardFourRight;
        break;
    }
    return tempImg
  }, []);

  return (
    <SlideCardWrap>
      <AnimateImgLeftWrap
        src={getLeftImg(index)}
        animate={{
          bottom: ["-20px", "10px", "-20px"],
          left: ["0px", "10px", "0px"],
        }}
        transition={{
          duration: 6,
          ease: "easeInOut",
          repeat: Infinity,
        }}
      ></AnimateImgLeftWrap>
      <AnimateImgRightWrap
        src={getRightImg(index)}
        animate={{
          right: ["-20px", "0px", "-20px"],
          top: ["0px", "10px", "0px"],
        }}
        transition={{
          duration: 6,
          ease: "easeInOut",
          repeat: Infinity,
        }}
      ></AnimateImgRightWrap>
      <BottomLayerWrap>
        <AnimatePresence>
          <AnimateRightBotLabelWrap
            key={index}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, right: "16px" }}
            exit={{ opacity: 0, right: "200px" }}
            transition={{
              duration: 1,
            }}
          >
            {type === "0" ? (
              <>
                <StyledContainer roobertSemiBold mr="3px">
                  {rightText} /{" "}
                </StyledContainer>
                {year}
              </>
            ) : (
              <StyledContainer roobertSemiBold fontSize="20px">
                {rightText}
              </StyledContainer>
            )}
          </AnimateRightBotLabelWrap>
        </AnimatePresence>

        <ProgressBarWrap>
          <AnimateProgressBarInWrap
            key={index}
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{
              duration: 5,
            }}
          ></AnimateProgressBarInWrap>
        </ProgressBarWrap>
      </BottomLayerWrap>
      <TopLayerWrap>
        <StyledContainer fontSize="14px" lineHeight="16px" color="#8a8e93">
          {type === "0" ? "Roadmap" : "Stats"}
        </StyledContainer>
        <StyledContainer
          nowrap
          mt="6px"
          fontSize="16px"
          lineHeight="20px"
          roobertMedium
        >
          <AnimatePresence>
            <AnimatedBox
              key={title}
              initial={{ opacity: 0, left: "-100%" }}
              animate={{ opacity: 1, left: "16px" }}
              exit={{ opacity: 0, left: "100%" }}
              transition={{
                duration: 1,
              }}
            >
              {title}
            </AnimatedBox>
          </AnimatePresence>
        </StyledContainer>
      </TopLayerWrap>
    </SlideCardWrap>
  );
};

const ImgLeftWrap = styled.img`
  position: absolute;
  width: 106px;
  height: 109px;
  bottom: -20px;
  left: 0;
  transform: rotate(-330deg);
  // transition: all ease-in-out 0.5s;
`;

const AnimateImgLeftWrap = styled(motion(ImgLeftWrap))``;

const ImgRightWrap = styled.img`
  position: absolute;
  width: 74px;
  height: 80px;
  top: 0;
  right: -10px;

  // transition: all ease-in-out 0.5s;
`;
const AnimateImgRightWrap = styled(motion(ImgRightWrap))``;

const SlideCardWrap = styled(StyledContainer)`
  width: 380px;
  height: 109px;
  position: relative;
  margin: 0 auto;

  &:hover {
    ${ImgLeftWrap} {
      bottom: -25px;
    }

    ${ImgRightWrap} {
      right: -15px;
    }
  }

  @media (max-width: 700px) {
    width: 360px;
  }
`;

const BottomLayerWrap = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(70px);
  -webkit-backdrop-filter: blur(70px);
  border-radius: 12px;
  box-shadow: 0 12px 22px 0 rgba(0, 0, 0, 0.07);

  position: relative;
  z-index: 1;
  overflow: hidden;
`;

const TopLayerWrap = styled.div`
  width: 231px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(70px);
  -webkit-backdrop-filter: blur(70px);
  border-radius: 12px;
  box-shadow: 0 12px 22px 0 rgba(0, 0, 0, 0.07);

  position: absolute;
  z-index: 1;
  top: 0;
  left: 4px;

  padding: 16px 0 16px 16px;
  box-sizing: border-box;
  overflow: hidden;
`;

const AnimatedBox = styled(motion.div)`
  position: absolute;
`;

const AnimateRightBotLabelWrap = styled(motion.div)`
  position: absolute;
  font-size: 14px;
  display: inline-flex;
  bottom: 16px;
  right: -100%;
  font-family: roobertLight;
`;

const ProgressBarWrap = styled(StyledContainer)`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 2px;
  background-color: #fff;
  border-radius: 2px;
`;

const AnimateProgressBarInWrap = styled(motion.div)`
  position: absolute;
  top: 0px;
  left: 0px;
  height: 2px;
  background-color: #e69e89;
  border-radius: 2px;
`;

export default SlideCardCom;
